/**
 * @file Automatically generated by barrelsby.
 */

export * from './tabstrip.module.ex';
export * from './tabstrip/index';
